import type { ReactElement } from 'react';

/**
 * One line saying which row a member with several matching rows sends (ACT2-1113): the most recent by
 * the audience's `latestBy` column, or always the same one by its `rowKey`. Read-only, like the joined
 * tables above it — the agent sets both. Renders nothing when the audience declares neither.
 */
export function RowPickNote({
  latestBy,
  rowKey,
}: {
  latestBy: string | undefined;
  rowKey: string | undefined;
}): ReactElement | null {
  if (latestBy) {
    return (
      <p className="mt-3 text-xs text-muted-foreground">
        When a member has several matching rows, the most recent by{' '}
        <code className="text-xs text-foreground">{latestBy}</code> is sent, one row per member.
      </p>
    );
  }
  if (rowKey) {
    return (
      <p className="mt-3 text-xs text-muted-foreground">
        When a member has several matching rows, the same one is always sent, chosen by{' '}
        <code className="text-xs text-foreground">{rowKey}</code>, one row per member.
      </p>
    );
  }
  return null;
}
